<main class="site-main">
    <!-- START OF HERO SECTION -->
    <section class="main-banner dark-bg">
        <div class="banner-stripes">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="banner-shape-wp wow fadeInLeft" data-wow-duration=".8s">
            <div class="banner-shape">
                <span class="stripe"></span>
                <span class="stripe stripe-secondary"></span>
            </div>
        </div>
        <div class="swiper main-banner-slider">
            <div class="swiper-wrapper">
                <div class="swiper-slide main-banner-slide">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="banner-content white-text">
                                    <h1 class="h1-title">
                                        Empower Your
                                        <span>
                                            Drive
                                            <img src="assets/img/title-line.svg" width="342" height="13"
                                                alt="Title line">
                                        </span>
                                    </h1>
                                    <p class="text-lg fs20">
                                        Leading automotive & industrial lubricants
                                    </p>
                                    <div class="banner-btn">
                                        <a routerLink="/about" class="sec-btn" title="Discover More">Discover
                                            More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="banner-image-path-main">
                                    <div class="banner-image-path-sub">
                                        <div class="banner-image back-img"
                                            style="background-image: url('assets/img/banner-image-oil-j.jpeg');">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide main-banner-slide">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="banner-content white-text">
                                    <h1 class="h1-title">
                                        Upgrade Ride With
                                        <span>
                                            GOLDOL
                                            <img src="assets/img/title-line.svg" width="342" height="13"
                                                alt="Title line">
                                        </span>
                                    </h1>
                                    <p class="text-lg fs20">
                                        Leading automotive & industrial lubricants
                                    </p>
                                    <div class="banner-btn">
                                        <a routerLink="/about" class="sec-btn" title="Discover More">
                                            Discover More
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="banner-image-path-main">
                                    <div class="banner-image-path-sub">
                                        <div class="banner-image back-img"
                                            style="background-image: url('assets/img/banner-image-oil2.jpg');">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF HERO SECTION -->
    <!-- START OF HERO SECTION -->
    <section class="about-us light-bg">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 text-center mb-5 pb-5">
                    <h1 class="mb-0 h3-title">
                        <span class="text-theme">GOLDOL Lubricants -</span> Dubai’s Trusted Lubricant Oil Supplier
                    </h1>
                </div>
                <div class="col-lg-6">
                    <div class="about-images wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".2s">
                        <div class="about-top-image back-img"
                            style="background-image: url('assets/img/Oil-Images/10W40-1.jpeg');">
                            <span class="logo-icon">
                                <img src="assets/img/logo-icon.svg" width="48" height="48" alt="Logo Icon">
                            </span>
                        </div>
                        <div class="about-bottom-image back-img"
                            style="background-image: url('assets/img/Oil-Images/20W50-1.jpeg');"></div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="about-us-content wow fadeInRight" data-wow-duration=".8s" data-wow-delay=".2s">
                        <div class="sec-title">
                            <span class="sub-title">
                                <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon">
                                ABOUT US
                            </span>
                            <p>
                                Golden Drop Oils takes its position as one of the most reliable <span
                                    class="text-theme fw-medium"> lubricant oil suppliers Dubai</span> customers can
                                rely upon. Our UAE-based company provides high-performance lubricants and engine oils
                                which serve different types of automotive vehicles combined with industrial along with
                                commercial clients throughout the UAE.
                            </p>
                        </div>
                        <div class="engineer-list">
                            <div class="engineer-list-item">
                                <span class="engineer-list-icon">
                                    <img src="assets/img/expert-engineer.svg" width="35" height="43"
                                        alt="Expert Engineer Logo">
                                </span>
                                <div class="engineer-list-content">
                                    <h6 class="h6-title">Quality Guarantee</h6>
                                </div>
                            </div>
                            <div class="engineer-list-item">
                                <span class="engineer-list-icon">
                                    <img src="assets/img/certified-engineer.svg" width="33" height="45"
                                        alt="Certified Engineer Logo">
                                </span>
                                <div class="engineer-list-content">
                                    <h6 class="h6-title">Powerful Performance</h6>
                                </div>
                            </div>
                        </div>
                        <a routerLink="/about" class="sec-btn" title="Discover More">Discover More</a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="about-us">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="about-us-content wow fadeInRight" data-wow-duration=".8s" data-wow-delay=".2s">
                        <div class="sec-title">
                            <h2 class="sub-title text-uppercase">
                                <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon">
                                What We Offer
                            </h2>
                            <p>
                                The company provides multiple top-quality lubricant options which encompass synthetic
                                fuel
                                systems alongside semi-synthetic and mineral-based oil products for gasoline and diesel
                                motors. Under Dubai's extreme climate the GOLDOL product line delivers protection and
                                wear resistance and fuel economy through its 5W30 10W40 20W50 options
                            </p>
                        </div>
                        <div class="sec-title mt-4 pt-2">
                            <h2 class="sub-title text-uppercase">
                                <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon">
                                Serving All of UAE
                            </h2>
                            <p>
                                Premium engine lubrication solutions are available to all customers across the entire
                                UAE
                                territory through our establishment Golden Drop Oils which operates from Sharjah and
                                Dubai. Our business consists of three distinct client types: retailers along with
                                workshops
                                and service centers followed by industrial operations that we provide products to boost
                                both
                                their engine efficiency and durability
                            </p>
                        </div>
                        <div class="sec-title mt-4 pt-2">
                            <h2 class="sub-title text-uppercase">
                                <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon">
                                Your Trusted Lubricant Partner
                            </h2>
                            <p>
                                You can count on Golden Drop Oils as the trusted lubricant oil suppliers Dubai selects
                                for
                                its excellence in product quality combined with dependable supply service. Golden Drop
                                enables you to achieve extended powerful driving at superior engine efficiency.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="about-images wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".2s">
                        <div class="about-top-image back-img"
                            style="background-image: url('assets/img/Oil-Images/10W40-1.jpeg');">
                            <span class="logo-icon">
                                <img src="assets/img/logo-icon.svg" width="48" height="48" alt="Logo Icon">
                            </span>
                        </div>
                        <div class="about-bottom-image back-img"
                            style="background-image: url('assets/img/Oil-Images/20W50-1.jpeg');"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="company-timeline wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s">
                        <span class="timeline-text">1995</span>
                        <div class="company-experiance">
                            <img src="assets/img/plus-icon.svg" width="20" height="20" alt="Plus Icon">
                            <div class="company-experiance-content">
                                <svg class="textcircle" viewBox="0 0 500 500">
                                    <defs>
                                        <path id="textcircle" d="M250,400 a150,150 0 0,1 0,-300a150,150 0 0,1 0,300Z">
                                        </path>
                                    </defs>
                                    <text>
                                        <textPath xlink:href="#textcircle" textLength="900">
                                            28 YEARS OF EXPERIANCE
                                        </textPath>
                                    </text>
                                </svg>
                            </div>
                        </div>
                        <span class="timeline-text">Since</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF HERO SECTION -->
    <!-- START OF SERVICE SECTION -->
    <section class="services light-bg">
        <div class="container">
            <div class="sec-title">
                <span class="sub-title h5-title m-0 wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s">
                    <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon">
                    WHAT WE PROVIDE
                </span>
                <h2 class="h3-title wow fadeInUp mt-3 mb-4" data-wow-duration=".8s" data-wow-delay=".2s">
                    High Performance & High Quality Oils
                </h2>
            </div>
            <div class="services-slider swiper wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" *ngFor="let prod of productsArr;let p = index;">
                        <div class="services-box">
                            <div class="services-image">
                                <div class="back-img" style="background-image: url({{prod?.image}});">
                                </div>
                            </div>
                            <div class="services-box-icon">
                                <img src="assets/img/all-maintenance-icon.svg" width="38" height="38"
                                    alt="All Maintenance Icon">
                            </div>
                            <div class="services-box-content">
                                <h5 class="h6-title">
                                    <a routerLink="/product-details/{{prod?.id}}"
                                        [title]="prod?.name">{{prod?.name}}</a>
                                </h5>
                                <p class="porduct-list-description">{{prod?.description}}</p>
                                <a routerLink="/product-details/{{prod?.id}}" class="sec-btn icon-lg"
                                    title="Go to All Maintenance"></a>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="swiper-pagination"></div>
            </div>
        </div>
    </section>
    <!-- END OF SERVICE SECTION -->
    <!-- START OF JOINING SECTION -->
    <section class="join-us wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="join-us-content dark-bg">
                        <div class="sec-title">
                            <span class="sub-title">
                                <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon">
                                JOIN NOW
                            </span>
                            <h3 class="h4-title text-white">Over 20+ Years of Experience in Lubricant Industry</h3>
                        </div>
                        <img src="assets/img/join-our-team.png" width="271" height="271" alt="Join our team image">
                        <a routerLink="/contact" class="sec-btn" title="Contact Us">Contact Us</a>
                        <div class="banner-shape">
                            <span class="stripe"></span>
                            <span class="stripe stripe-secondary"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF JOINING SECTION -->
    <!-- START OF SKILLS SECTION -->
    <section class="skills">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 order-lg-2">
                    <div id="counter" class="skills-content wow fadeInRight" data-wow-duration=".8s"
                        data-wow-delay=".2s">
                        <div class="sec-title">
                            <span class="sub-title">
                                <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon">
                                Why Choose Us?
                            </span>
                            <p>
                                The Dubai-based premier <span class="text-theme fw-medium">lubricant oil suppliers
                                    Dubai</span> organization fulfills its commitment to serve customers through:
                            </p>
                        </div>
                        <div class="skills-progress">
                            <div class="skills-progress-box">
                                <h6 class="h6-title">
                                    Quality Services
                                    <span>
                                        <span class="skill-count counting" data-count="90">0</span>%</span>
                                </h6>
                                <div class="skills-progressbar">
                                    <div class="skills-progressbar-thumb" style="width: 0%;" data-width="90%"></div>
                                </div>
                            </div>
                            <div class="skills-progress-box">
                                <h6 class="h6-title">
                                    Team Dedication
                                    <span>
                                        <span class="skill-count counting" data-count="95">0</span>%</span>
                                </h6>
                                <div class="skills-progressbar">
                                    <div class="skills-progressbar-thumb" style="width: 0%;" data-width="95%"></div>
                                </div>
                            </div>
                        </div>
                        <div class="skills-counter">
                            <div class="skills-count projects-done">
                                <div class="counting-wp text-center">
                                    <div class="h3-title justify-content-center">
                                        <strong class="counting" data-count="16">0</strong>
                                        <span>+</span>
                                    </div>
                                    <span>Years of Experience</span>
                                </div>
                            </div>
                            <div class="skills-count worker-team">
                                <div class="counting-wp text-center">
                                    <div class="h3-title justify-content-center">
                                        <strong class="counting" data-count="1000">0</strong>
                                        <span>+</span>
                                    </div>
                                    <span>Shipments Per Year</span>
                                </div>
                            </div>
                        </div>

                        <div class="skills-counter">
                            <div class="skills-count satisfied-clients">
                                <div class="counting-wp text-center">
                                    <div class="h3-title justify-content-center">
                                        <strong class="counting" data-count="100">0</strong>
                                        <span>+</span>
                                    </div>
                                    <span>Workers Employed</span>
                                </div>
                            </div>
                            <div class="skills-count satisfied-clients">
                                <div class="counting-wp text-center">
                                    <div class="h3-title justify-content-center">
                                        <strong class="counting" data-count="50">0</strong>
                                        <span>+</span>
                                    </div>
                                    <span>Countries Export</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 order-lg-1 align-self-lg-center">
                    <div class="process-content-wp wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".2s">
                        <div class="process-item w-100">
                            <div class="process-step">
                                <p class="h4-title">1</p>
                            </div>
                            <div class="process-content">
                                <h4 class="h5-title m-0">International-quality standards (API SN/SL/CF)</h4>
                            </div>
                        </div>
                        <div class="process-item w-100">
                            <div class="process-step">
                                <p class="h4-title">2</p>
                            </div>
                            <div class="process-content">
                                <h4 class="h5-title m-0">Advanced engine protection</h4>
                            </div>
                        </div>
                        <div class="process-item w-100">
                            <div class="process-step">
                                <p class="h4-title">3</p>
                            </div>
                            <div class="process-content">
                                <h4 class="h5-title m-0">Bulk supply and wholesale distribution</h4>
                            </div>
                        </div>
                        <div class="process-item w-100">
                            <div class="process-step">
                                <p class="h4-title">4</p>
                            </div>
                            <div class="process-content">
                                <h4 class="h5-title m-0">Competitive prices and prompt delivery</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF SKILLS SECTION -->

    <!-- START OF FAQ SECTION -->
    <section class="faq-section dark-bg">
        <div class="banner-shape">
            <span class="stripe"></span>
            <span class="stripe stripe-secondary"></span>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-6 order-lg-1 order-2 align-self-center">
                    <div class="faq-content wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".2s">
                        <div class="sec-title">
                            <span class="sub-title">
                                <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon">
                                FAQ
                            </span>
                            <h2 class="h3-title m-0 text-white">Do You Have Any Question ?</h2>
                        </div>
                        <div class="faq-accordian white-text">
                            <div class="faq-accordian-box">
                                <div class="faq-accordian-title">
                                    <h6 class="h6-title fw-medium">What industries do you serve?</h6>
                                    <span class="icon"></span>
                                </div>
                                <div class="faq-accordian-content">
                                    <p>GOLDOL Lubricants serves various industries, including automotive, industrial,
                                        marine, hydraulic, and engine care sectors.</p>
                                </div>
                            </div>
                            <div class="faq-accordian-box">
                                <div class="faq-accordian-title">
                                    <h6 class="h6-title fw-medium">How can I become a distributor for GOLDOL Lubricants?
                                    </h6>
                                    <span class="icon"></span>
                                </div>
                                <div class="faq-accordian-content">
                                    <p>It's easy! Contact us to become a distributor for GOLDOL Lubricants, a leading
                                        supplier in the UAE. We provide full support, including access to our product
                                        catalog and marketing materials.</p>
                                </div>
                            </div>
                            <div class="faq-accordian-box">
                                <div class="faq-accordian-title">
                                    <h6 class="h6-title fw-medium">Are GOLDOL Lubricants environmentally friendly?</h6>
                                    <span class="icon"></span>
                                </div>
                                <div class="faq-accordian-content">
                                    <p>
                                        Absolutely! GOLDOL Lubricants, as one of the industrial lubricant manufacturers
                                        in UAE, prioritizes sustainability. Our eco-friendly lubricants meet strict
                                        standards, making us a trusted choice among petroleum products suppliers in the
                                        UAE.
                                    </p>
                                </div>
                            </div>
                            <div class="faq-accordian-box">
                                <div class="faq-accordian-title">
                                    <h6 class="h6-title fw-medium">What makes GOLDOL Lubricants different from other
                                        manufacturers?</h6>
                                    <span class="icon"></span>
                                </div>
                                <div class="faq-accordian-content">
                                    <p>GOLDOL Lubricants stands out due to our long-standing industry leadership,
                                        unwavering commitment to quality, and continuous innovation. We design our
                                        products to exceed expectations in terms of performance, reliability, and
                                        affordability, ensuring that our customers can trust us to safeguard their
                                        valuable machinery.</p>
                                </div>
                            </div>
                            <div class="faq-accordian-box">
                                <div class="faq-accordian-title">
                                    <h6 class="h6-title fw-medium">Where can you find the top-quality engine oil in the
                                        UAE to maximize your engine's performance?</h6>
                                    <span class="icon"></span>
                                </div>
                                <div class="faq-accordian-content">
                                    <p>
                                        In the UAE, you can easily get top-notch engine oils, like those made by GOLDOL
                                        Lubricants, designed to make your engine perform at its best.
                                    </p>
                                </div>
                            </div>
                            <div class="faq-accordian-box">
                                <div class="faq-accordian-title">
                                    <h6 class="h6-title fw-medium">What makes GOLDOL Lubricants the go-to choice for
                                        lubricants in the UAE?</h6>
                                    <span class="icon"></span>
                                </div>
                                <div class="faq-accordian-content">
                                    <p>
                                        GOLDOL Lubricants stands out as the premier lubricant company in the UAE,
                                        providing a wide range of top-quality lubricants and dedicated customer service.
                                    </p>
                                </div>
                            </div>
                            <div class="faq-accordian-box">
                                <div class="faq-accordian-title">
                                    <h6 class="h6-title fw-medium">What kinds of lubricants does GOLDOL offer?</h6>
                                    <span class="icon"></span>
                                </div>
                                <div class="faq-accordian-content">
                                    <p>
                                        GOLDOL is a top manufacturer and supplier of high-quality engine oils, motor
                                        oils, and lubricants in the UAE and worldwide. We offer a wide range of products
                                        for vehicles from motorcycles to heavy-duty trucks, as well as industrial
                                        lubricants for various applications like marine, construction, automotive, and
                                        more.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 order-lg-2 order-1">
                    <div class="in-touch-form wow fadeInRight" data-wow-duration=".8s" data-wow-delay=".2s">
                        <h3 class="h3-title">Get In Touch Now !</h3>
                        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-field">
                                        <input type="text" class="input-field" placeholder="Full Name"
                                            formControlName="name">
                                        <div *ngIf="submitted && con['name'].errors" class="abs-error">
                                            <div *ngIf="con['name'].errors['required']">Full Name is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-field">
                                        <input type="email" class="input-field" placeholder="Email Address"
                                            formControlName="email">
                                        <div *ngIf="submitted && con['email'].errors" class="abs-error">
                                            <div *ngIf="con['email'].errors['required']">Email is required</div>
                                            <div *ngIf="con['email'].errors['pattern']">Please enter a valid email
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-field">
                                        <input type="text" class="input-field" placeholder="Phone No."
                                            formControlName="phone" (keypress)="numberOnly($event)" />
                                        <div *ngIf="submitted && con['phone'].errors" class="abs-error">
                                            <div *ngIf="con['phone'].errors['required']">
                                                Phone number is required
                                            </div>
                                            <div *ngIf="con['phone'].errors['minlength']">
                                                Minimum 10 numbers required
                                            </div>
                                            <div *ngIf="con['phone'].errors['maxlength']">
                                                Maximum 10 numbers required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-field">
                                        <textarea name="message" class="input-field" placeholder="Message..."
                                            formControlName="message"></textarea>
                                        <div *ngIf="submitted && con['message'].errors" class="abs-error">
                                            <div *ngIf="con['message'].errors['required']">Message is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-field form-submit-btn">
                                        <button type="submit" class="sec-btn">Submit now</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF FAQ SECTION -->
    <!-- START OF TESTIMONIALS SECTION -->
    <section class="testimonials">
        <img src="assets/img/globe.svg" class="bg-glob" width="687" height="744" alt="Globe Icon">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="sec-title">
                        <span class="sub-title wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s">
                            <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon">
                            TESTIMONIAL
                        </span>
                        <h2 class="h3-title mt-3 mb-4 wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s">What
                            Client Say About Us</h2>
                    </div>
                    <div class="swiper testimonial-slider wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <div class="testimonial-box">
                                    <span class="quote_icon"></span>
                                    <div class="testimonial-author">
                                        <div class="author-img">
                                            <div class="back-img"
                                                style="background-image: url(assets/img/mark-john.jpg);"></div>
                                        </div>
                                        <div class="author-content">
                                            <h4 class="h4-title">Mark John</h4>
                                            <span>Our Client</span>
                                            <div class="star-rating-wp">
                                                <div class="star-rating">
                                                    <span class="star-rating__fill" style="width: 96%"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="testimonial-content">
                                        <div class="testimonial-text overflow-text" data-simplebar>
                                            <p>In hac habitasse platea dictumst. Mauris tortor mauris, ornare non
                                                efficitur et, condimentum ac magna. Vivamus rutrum enim vel elit
                                                pharetra, et mollis tellus porta. Quisque quis augue elementum,
                                                bibendum odio id, lobortis lacus. Ut commodo ac enim sit amet
                                                pellentesque. Aliquam sodales a leo sed aliquam.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="testimonial-box">
                                    <span class="quote_icon"></span>
                                    <div class="testimonial-author">
                                        <div class="author-img">
                                            <div class="back-img"
                                                style="background-image: url(assets/img/patrick-palmer.jpg);">
                                            </div>
                                        </div>
                                        <div class="author-content">
                                            <h4 class="h4-title">Mark John</h4>
                                            <span>Our Client</span>
                                            <div class="star-rating-wp">
                                                <div class="star-rating">
                                                    <span class="star-rating__fill" style="width: 96%"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="testimonial-content">
                                        <div class="testimonial-text overflow-text" data-simplebar>
                                            <p>In hac habitasse platea dictumst. Mauris tortor mauris, ornare non
                                                efficitur et, condimentum ac magna. Vivamus rutrum enim vel elit
                                                pharetra, et mollis tellus porta. Quisque quis augue elementum,
                                                bibendum odio id, lobortis lacus. Ut commodo ac enim sit amet
                                                pellentesque. Aliquam sodales a leo sed aliquam.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="testimonial-box">
                                    <span class="quote_icon"></span>
                                    <div class="testimonial-author">
                                        <div class="author-img">
                                            <div class="back-img"
                                                style="background-image: url(assets/img/mark-john.jpg);"></div>
                                        </div>
                                        <div class="author-content">
                                            <h4 class="h4-title">Mark John</h4>
                                            <span>Our Client</span>
                                            <div class="star-rating-wp">
                                                <div class="star-rating">
                                                    <span class="star-rating__fill" style="width: 96%"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="testimonial-content">
                                        <div class="testimonial-text overflow-text" data-simplebar>
                                            <p>In hac habitasse platea dictumst. Mauris tortor mauris, ornare non
                                                efficitur et, condimentum ac magna. Vivamus rutrum enim vel elit
                                                pharetra, et mollis tellus porta. Quisque quis augue elementum,
                                                bibendum odio id, lobortis lacus. Ut commodo ac enim sit amet
                                                pellentesque. Aliquam sodales a leo sed aliquam.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="testimonial-pagination"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF TESTIMONIALS SECTION -->
</main>